import { get, post } from './httpClient'

export const createProductType = (object) => post('/producttype/create', object)
export const searchProductType = (object) => get('/producttype', object)
export const updateProductType = (object) => post('/producttype/update', object)
export const deleteProductType = (_id) => post('/producttype/delete', { _id })
export const getProductType = () => get('/producttype')
export const duplicateProductType = (_id) => post('/producttype/x2', { _id })
export const getCountry = () => get('/country')
